import { render, staticRenderFns } from "./TextChoiceQuestion.vue?vue&type=template&id=47c3a181&scoped=true"
import script from "./TextChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TextChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TextChoiceQuestion.vue?vue&type=style&index=0&id=47c3a181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3a181",
  null
  
)

export default component.exports